import React from 'react';
import { Alert, Button, Box, Typography } from '@mui/material';
import { Info as InfoIcon, Link as LinkIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

export const LimitedAccessBanner: React.FC = () => {
  const navigate = useNavigate();
  const { requiresProfileClaim, hasSkippedProfileClaim } = useAuth();

  // Only show banner if user has skipped profile claiming
  if (!requiresProfileClaim || !hasSkippedProfileClaim) {
    return null;
  }

  const handleLinkProfile = () => {
    navigate('/claim-profile');
  };

  return (
    <Alert
      severity="info"
      icon={<InfoIcon />}
      sx={{
        borderRadius: 0,
        borderBottom: '1px solid',
        borderBottomColor: 'divider',
        '& .MuiAlert-message': {
          width: '100%',
        },
      }}
      action={
        <Button
          color="inherit"
          size="small"
          startIcon={<LinkIcon />}
          onClick={handleLinkProfile}
          sx={{ whiteSpace: 'nowrap' }}
        >
          Link Profile
        </Button>
      }
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Typography variant="body2">
          <strong>Limited Access:</strong> Link your member profile to access all features and
          member benefits.
        </Typography>
      </Box>
    </Alert>
  );
};

export default LimitedAccessBanner;
